import type {
  ModulesSelectProps,
  ModulesSelectOptionItemData,
  ModulesSelectOptionItemValue,
} from "./modules-select.type";

import { useTranslation } from "react-i18next";

import QueryableSelect from "@/modules/queryable-select";

import ModulesSelectOption from "./modules-select-option";
import { MODULES_FIELD_NAME } from "./modules-select.constant";

const ModulesSelect = ({ ...props }: ModulesSelectProps) => {
  const { t } = useTranslation();
  const label = t("interventionTemplate:form.modules.label");

  return (
    <QueryableSelect<ModulesSelectOptionItemValue, ModulesSelectOptionItemData>
      data-testid="modules-select"
      name={MODULES_FIELD_NAME}
      model="modules"
      mode="multiple"
      filterBy="name"
      label={label}
      placeholder={label}
      optionFormat={ModulesSelectOption}
      {...props}
    />
  );
};

export default ModulesSelect;
